/** Global function provides an ajax requests. */
export const getResources = (options, url, data) => {
  return jQuery.ajax({
    beforeSend: (xhr, settings) => {
      xhr.setRequestHeader('X-CSRFToken', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))
    },
    data: data || {},
    method: options.method || 'GET',
    url,
  })
}
